module.exports = __webpack_public_path__ + "13db5b89a55408406f73406249e05cd2.svg";